import { Product } from "../../../graphql/operations";
import ProductCard from "../ProductCard";
import styles from "./ProductCardList.module.css";

type ProductCardListProps = {
  products: Omit<
    Product,
    | "meetingPlaceGoogleMapsQuery"
    | "hasAccomodationVehiclePickup"
    | "hasDefaultVehiclePickup"
  >[];
};

export default function ProductCardList({ products }: ProductCardListProps) {
  return (
    <div className={styles.ProductCardListWrapper}>
      <div className={styles.ProductCardList}>
        {products.length > 0 &&
          products.map((product) => {
            return <ProductCard key={product.id} {...product} />;
          })}
      </div>
    </div>
  );
}
